import { AssistantPreferencesSection } from './AssistantPreferencesSection';
import { ProfileSection } from './ProfileSection';
import { ContactSection } from './ContactSection';
import { PreferencesSection } from './PreferencesSection';
import { SecuritySection } from './SecuritySection';

export function MyAccountSection() {
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-5 items-start">
      <ProfileSection />
      <ContactSection />
      <PreferencesSection />
      <SecuritySection />
      <AssistantPreferencesSection />
    </div>
  );
}
